const cardItems = [
  {
    title: '某综艺录制现场突发状况，导演紧急叫停',
    summary: '据现场工作人员透露，录制过程中因嘉宾言论过于敏感，总导演当即叫停录制并紧急召开协调会。',
    tag: '综艺',
    time: '3小时前',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20with%20warm%20crimson%20emergency%20lights%2C%20abstract%20crew%20silhouettes%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20aesthetic%2C%20editorial%20photography%20style%2C%20clean%20composition&width=640&height=420&seq=card-01&orientation=landscape',
  },
  {
    title: '知名品牌紧急更换代言人，疑似受到舆论影响',
    summary: '该品牌在社交媒体发布声明宣布与原代言人终止合作，有分析认为这与近期该艺人的负面舆论有关。',
    tag: '代言',
    time: '5小时前',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20luxury%20brand%20billboard%20being%20changed%20with%20warm%20amber%20sunset%20lighting%2C%20abstract%20urban%20street%20scene%2C%20commercial%20photography%20aesthetic%2C%20clean%20composition%2C%20editorial%20style&width=640&height=420&seq=card-02&orientation=landscape',
  },
  {
    title: '某女星新恋情疑似曝光，男方身份引热议',
    summary: '有媒体拍到某当红女星与一男子亲密出行，经网友深扒男方疑似为圈外某科技公司高管。',
    tag: '恋情',
    time: '7小时前',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20romantic%20evening%20street%20scene%20with%20warm%20crimson%20and%20amber%20neon%20lights%2C%20abstract%20couple%20silhouettes%2C%20paparazzi%20style%20photography%2C%20mysterious%20atmosphere%2C%20editorial%20composition%2C%20clean%20background&width=640&height=420&seq=card-03&orientation=landscape',
  },
  {
    title: '选秀节目导师阵容曝光，多位大咖确认加盟',
    summary: '新一季选秀节目导师名单流出，包括多位音乐界和影视界的重量级人物，阵容豪华程度超乎预期。',
    tag: '选秀',
    time: '9小时前',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20talent%20show%20stage%20with%20warm%20crimson%20spotlights%2C%20empty%20judges%20chairs%2C%20abstract%20audience%20lighting%2C%20grand%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20composition&width=640&height=420&seq=card-04&orientation=landscape',
  },
  {
    title: '网剧剧组拖欠工资，群众演员集体维权',
    summary: '某正在拍摄的网络剧被曝拖欠群演工资长达三个月，数十名群众演员在拍摄地外集体维权引发关注。',
    tag: '剧组',
    time: '11小时前',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20exterior%20with%20warm%20amber%20sunset%20lighting%2C%20abstract%20gathering%20crowd%20silhouettes%2C%20protest%20atmosphere%2C%20documentary%20photography%20style%2C%20clean%20composition%2C%20editorial%20aesthetic&width=640&height=420&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">最新爆料</h2>
              <p className="text-sm text-foreground-600 mt-1">最新上线的吃瓜内容</p>
            </div>
            <span className="text-xs text-foreground-500 flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              持续更新中
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.slice(0, 3).map((item, i) => (
              <article
                key={i}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-sm text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.summary}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className="text-xs text-primary-600 font-medium group-hover:underline whitespace-nowrap cursor-pointer">阅读全文</span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {cardItems.slice(3).map((item, i) => (
              <article
                key={i + 3}
                className="group flex flex-col sm:flex-row gap-4 rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer p-0"
              >
                <div className="sm:w-48 h-36 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-4 sm:py-4 sm:pr-4 sm:pl-0 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-bold whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="font-bold text-sm text-foreground-900 leading-snug mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}